import styled from 'styled-components';

export const CardContainer = styled.div`
  width: 100%;
  height: 150px;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  padding: 22px 18px 18px 22px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CardLeft = styled.div`
  display: flex;
  width: 60%;
  flex-direction: column;
  justify-content: space-between;
`;

export const CardNameAndLogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  img {
    width: 30px;
    height: 30px;
    border-radius: 100px;
  }
`;

export const StarsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const AvailableDriversContainer = styled.div`
  color: white;
  background-color: #2222a7;
  text-align: center;
  border-radius: 10px;
  padding: 8px;
`;

export const CardNameText = styled.text`
  font-size: 20px;
`;

export const CardRight = styled.div`
  display: flex;
  width: 30%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const CardValueContainer = styled.div`
  background-color: #d9d9d9;
  padding: 5px 11px;
  border-radius: 20px;
  visibility: ${({ isFirstFetch }) => (isFirstFetch ? 'hidden' : 'visible')};
  display: flex;
`;

export const CardValueText = styled.text`
  font-size: 25px;
`;

export const OpenButton = styled.button`
  width: 100%;
  height: 50px;
  background-color: #ff4406;
  filter: none !important;
  color: white;
  border-radius: 20px;
`;
